// Global axios error normaliser.
//
// The backend returns FastAPI 422 validation errors as an ARRAY of objects
// shaped like `{type, loc, msg, input, ctx}`. Many call sites do
//   toast.error(err.response?.data?.detail || "…")
// which, if `detail` is an array of objects, ends up asking React to render
// an object → "Objects are not valid as a React child" crash.
//
// This interceptor coerces `detail` into a friendly human string BEFORE any
// component ever sees it, so all existing call sites keep working.

import axios from "axios";

const flatten = (detail) => {
  if (!detail) return "";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((d) => {
        if (typeof d === "string") return d;
        if (d && typeof d === "object") {
          const loc = Array.isArray(d.loc) ? d.loc.slice(1).join(".") : "";
          const msg = d.msg || d.message || "Validation error";
          return loc ? `${loc}: ${msg}` : msg;
        }
        return String(d);
      })
      .filter(Boolean)
      .join("; ");
  }
  if (typeof detail === "object") {
    if (detail.msg) return String(detail.msg);
    try { return JSON.stringify(detail); } catch { return "Request failed"; }
  }
  return String(detail);
};

let installed = false;
export function installAxiosErrorNormaliser() {
  if (installed) return;
  installed = true;
  axios.interceptors.response.use(
    (r) => r,
    (err) => {
      try {
        if (err && err.response && err.response.data && err.response.data.detail !== undefined) {
          const s = flatten(err.response.data.detail);
          err.response.data.detail = s || "Request failed";
        }
      } catch { /* ignore */ }
      return Promise.reject(err);
    },
  );
}
